/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  comercial: boolean;
}

export function usePropostasFiltrosEtapas(props: Props) {
  const LISTAR_ETAPA = `${backofficeEnviroment}/common/backoffice/etapas/v1?Comercial=${props.comercial}`;
  const fetchData = async () => {
    const response = await instance.get(LISTAR_ETAPA);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["propostas-filtro-etapas"],
    refetchOnWindowFocus: false,
  });
  return query;
}
